const riot = require('riot');

riot.tag2('atom-role', '<div class="w72 rounded-4 f fh py2 lh13 text-white fs12 font-lato {app.utils.getRoleClass(opts.role)}">{opts.role}</div>', '', '', function(opts) {
});